import axiosInstance from "../../axios/axiosInstance";
import { APPROVE_ORDER, COMPLETED_ORDERS_LISTING, DELETE_ORDER_ITEM, DELETE_PRODUCT_ITEM, DOWNLOAD_ORDERS_EXCEL, DOWNLOAD_VENDOR_INVOICE, EXCHANGE_REJECT_ORDER, ORDERS_DETAILS_LISTING, ORDERS_LISTING, PAYMENT_LISTING_URL, REJECTED_ORDERS_LISTING, REJECT_ORDER, SHIP_ORDER, TRACKING_LISTING, UPDATE_PAYMENT_STATUS, UPDATE_TRACKING_STATUS } from "../../constants";

export const getOrdersListing = (props) => (onResponse) => {
    try {
        console.log('order api', props);
        let BASE_URL = ORDERS_LISTING;
        axiosInstance
            .post(BASE_URL, props)
            .then((response) => {
                console.log('order api repsonse', response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) { }
};

export const getCompletedOrdersListing = (props) => (onResponse) => {
    try {
        let BASE_URL = COMPLETED_ORDERS_LISTING;
        axiosInstance
            .post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) { }
};


export const getRejectedOrdersListing = (props) => (onResponse) => {
    try {
        let BASE_URL = REJECTED_ORDERS_LISTING;
        axiosInstance
            .post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) { }
};


export const getOrderDetails = (id) => onResponse => {

    try {
        axiosInstance.post(ORDERS_DETAILS_LISTING, { orderId: id })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const approveOrder = (props) => onResponse => {

    try {
        axiosInstance.post(APPROVE_ORDER, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const rejectOrder = (props) => onResponse => {

    try {
        axiosInstance.post(REJECT_ORDER, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const deleteOrderProduct = (id) => onResponse => {

    try {
        axiosInstance.post(DELETE_PRODUCT_ITEM, { orderproductId: id })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const deleteOrderItem = (id) => onResponse => {
    try {
        axiosInstance.delete(DELETE_ORDER_ITEM, { data: { orderId: id } })
            .then((response) => {
                console.log(response, "*//*/*/*/");
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const shipOrder = (props) => onResponse => {

    try {
        axiosInstance.post(SHIP_ORDER, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getPaymentListing = (props) => onResponse => {
    try {
        let BASE_URL = PAYMENT_LISTING_URL
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const exchangeorRejectOrder = (props) => onResponse => {

    try {
        axiosInstance.post(EXCHANGE_REJECT_ORDER, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};


export const updatePaymentStatus = (props) => (onResponse) => {
    try {
        axiosInstance.post(UPDATE_PAYMENT_STATUS, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response ? err.response.data : err);
            });
    } catch (error) {
        onResponse({ error: 'Exception occurred while updating payment status.' });
    }
};


export const getTrackingOrdersListing = (props) => (onResponse) => {
    try {
        let BASE_URL = TRACKING_LISTING;
        axiosInstance
            .post(BASE_URL, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err);
                onResponse(err);
            });
    } catch (error) { }
};


export const updateTrackingStatus = (props) => (onResponse) => {
    try {
        axiosInstance.post(UPDATE_TRACKING_STATUS, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response ? err.response.data : err);
            });
    } catch (error) {
        onResponse({ error: 'Exception occurred while updating order status.' });
    }
};


export const downloadVendorInvoice = (props) => (onResponse) => {

   try {
        axiosInstance.get(DOWNLOAD_VENDOR_INVOICE, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err.response ? err.response.data : err);
            });
    } catch (error) {
        onResponse({ error: 'Exception occurred while downloading invoice' });
    }
};


export const downloadOrdersExcelSheet = (props) => {
  try {
    return axiosInstance.post(DOWNLOAD_ORDERS_EXCEL, props, {
      responseType: "blob", // important for file download
    });
  } catch (error) {
    console.error("Download Excel Error:", error);
  }
};